import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-89cc6a26")

_pushScopeId("data-v-89cc6a26")
const _hoisted_1 = { class: "splitBySelect" }
const _hoisted_2 = /*#__PURE__*/_createVNode("p", null, "出力するコマの選択：", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.editedImgs, (source, i) => {
      return (_openBlock(), _createBlock("div", {
        class: "frame",
        key: i
      }, [
        _createVNode("input", {
          id: `preview_${i}`,
          type: "checkbox",
          value: i,
          checked: _ctx.selectFrames.includes(i),
          onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.updateValue && _ctx.updateValue(...args)))
        }, null, 40, ["id", "value", "checked"]),
        _createVNode("label", {
          for: `preview_${i}`
        }, [
          _createVNode("img", {
            src: source.src,
            class: "preview"
          }, null, 8, ["src"])
        ], 8, ["for"])
      ]))
    }), 128))
  ]))
})